import { Box, Grid, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router';
import { ArrowBackIcon } from './icon';

const Heading = ({name}) => {
     const navigate = useNavigate();

  return (
    <Grid container alignItems="center" spacing={2}>
            {/* Back Icon */}
            <Grid item>
              <ArrowBackIcon
                sx={{ cursor: "pointer" }}
                onClick={() => navigate("/home")}
              />
            </Grid>
    
            {/* Title Section */}
            <Grid item xs>
              <Box
                sx={{
                  background:
                    "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                  padding: "10px",
                  mt: "10px",
                  borderRadius: "5px",
                  color: "#01008B",
                  textAlign: "left",
                  marginBottom: "20px",
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: "20px",
                  fontWeight: 500,
                }}
              >
                <Typography
                  sx={{
                    typography: { xs: "h6", sm: "h6" },
                  fontSize:{ xs: "12px", sm: "13px", md: "15px" }
                  }}
                >
                  {name}
                </Typography>
              </Box>
            </Grid>
          </Grid>
  )
}

export default Heading
